var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteItemization = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.625v1.313c0 .309-.253.562-.563.562h-7.875a.564.564 0 0 1-.562-.563v-1.312c0-.31.253-.563.563-.563h7.874c.31 0 .563.254.563.563zM18.937 18h-7.875a.564.564 0 0 0-.562.563v1.312c0 .31.253.563.563.563h7.874c.31 0 .563-.254.563-.563v-1.313a.564.564 0 0 0-.563-.562zM24 9.183V24.75A2.25 2.25 0 0 1 21.75 27H8.25A2.25 2.25 0 0 1 6 24.75V5.25A2.25 2.25 0 0 1 8.25 3h9.567c.596 0 1.167.24 1.59.66l3.932 3.934c.422.417.661.994.661 1.589zm-6-3.75V9h3.567L18 5.433zm3.75 19.317v-13.5h-4.875a1.122 1.122 0 0 1-1.125-1.125V5.25h-7.5v19.5h13.5z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteItemization);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-itemization.6f8d19674be9a4087ed30d54f58ddbc4.svg";